class FooterDropdown extends HTMLElement{
    constructor(){
        super();
        this.button = this.querySelector("button");
        this.content = this.querySelector(".footer-details-content");

        this.button.addEventListener("click",this.handler.bind(this))
    }

    handler(){
        this.button.classList.toggle("active");
        if (this.content.style.maxHeight) {
            this.content.style.maxHeight = null;
        } else {
            this.content.style.maxHeight = this.content.scrollHeight + "px";
        }
    }
}

customElements.define("footer-dropdown",FooterDropdown)